<script setup lang="ts">
import VideoDetailPage from '~/components/Unified/Video/VideoDetailPage.vue';
import { IaPageAudience } from '~/composables/unified/useIaAudience';

definePageMeta({
  authType: [AUTH_ROUTE_TYPE_NONE],
  name: 'videos-slug',
  layout: 'unified-public',
  // A signed-in student under the new information architecture watches it inside the coach shell.
  ia: { audience: IaPageAudience.All, on: '/coach/videos/:slug', fullWidth: true },
  iaBack: true,
});
</script>

<template>
  <VideoDetailPage />
</template>
